import { ExportCategory, ExportSettingItem } from "./types";

export const ExportSettingsItems: ExportSettingItem[] = [
  {
    main: "Export settings",
    subItems: [
      ExportCategory.Installs,
      ExportCategory.Contracts,
      ExportCategory.FunctionalAreaIntelligence,
    ],
  },
  {
    main: "Spend Sheet",
    subItems: [
      ExportCategory.ITSpend,
      ExportCategory.AISpend,
      ExportCategory.ProductsAndVendors,
      ExportCategory.CloudMaturity,
    ],
  },
  {
    main: "Export",
  },
];

export const MAX_EXPORT_COMPANIES = 25000;
